var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { Box, Grid, Typography, FormControlLabel, Checkbox, } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { contributeToOkagesamaNoMori as api, offerList as offerListApi, } from '../../../api';
import { currencies } from '../../../constants/currency';
import { formatMoneyAmount } from '../../../utils/format';
import { useRequest } from '../../../hooks/requestHook';
import { useContributeToOkagesamaNoMoriColumns } from '../../../hooks/useColumns';
import { useNotify } from '../../../hooks/notificationHook';
import MaterialTable from '../../MaterialTable';
var OkagesamaNoMoriContributorTable = function (_a) {
    var offerList = _a.offerList, onChange = _a.onChange;
    var t = useTranslation().t;
    var notify = useNotify();
    var _b = React.useState(false), loading = _b[0], setLoading = _b[1];
    var _c = React.useState('0'), totalPricesByUsd = _c[0], setTotalPricesByUsd = _c[1];
    var _d = React.useState({}), totalPricesByCurrency = _d[0], setTotalPricesByCurrency = _d[1];
    var _e = React.useState([]), contributeToOkagesamaNoMoris = _e[0], setContributeToOkagesamaNoMoris = _e[1];
    var getAll = useRequest(api.getAll);
    var updateOfferList = useRequest(offerListApi.update);
    var contributeToOkagesamaNoMoriColumns = useContributeToOkagesamaNoMoriColumns();
    var columns = [
        contributeToOkagesamaNoMoriColumns.roasterId,
        contributeToOkagesamaNoMoriColumns.roasterLastname,
        contributeToOkagesamaNoMoriColumns.roasterFirstname,
        contributeToOkagesamaNoMoriColumns.price,
    ];
    React.useEffect(function () {
        var canceled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, getAll({ offer_list_id: offerList.id })];
                    case 1:
                        response = _a.sent();
                        if (canceled)
                            return [2 /*return*/];
                        setLoading(false);
                        if (!response)
                            return [2 /*return*/];
                        setTotalPricesByUsd(response.meta.contributeToOkagesamaNoMorisTotalPricesByUsd);
                        setTotalPricesByCurrency(response.meta.contributeToOkagesamaNoMorisTotalPricesByCurrency);
                        setContributeToOkagesamaNoMoris(response.data);
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [offerList, getAll]);
    var updateOfferListRequest = React.useCallback(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, updateOfferList(data)];
                case 1:
                    response = _a.sent();
                    setLoading(false);
                    if (!response)
                        return [2 /*return*/];
                    onChange(response);
                    notify('success', [t('messages.updateSuccess')]);
                    return [2 /*return*/];
            }
        });
    }); }, [t, updateOfferList, onChange, notify]);
    var handleCheckboxChange = React.useCallback(function (event, checked) {
        var _a;
        var name = event.target.name;
        var data = { id: offerList.id, offer_list: (_a = {}, _a[name] = checked, _a) };
        updateOfferListRequest(data);
    }, [offerList, updateOfferListRequest]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { px: 1, py: 2 },
            React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                    React.createElement(Typography, { variant: "subtitle1" }, t('pages.offerList.okagesamaNoMoriTotalPrices'))),
                React.createElement(Grid, { item: true, xs: 12, sm: 9 },
                    React.createElement(Typography, { variant: "body2" }, "".concat(formatMoneyAmount(totalPricesByUsd, 'USD'), " (").concat(currencies
                        .map(function (currency) {
                        return formatMoneyAmount(totalPricesByCurrency[currency] || 0, currency);
                    })
                        .join(', '), ")"))),
                React.createElement(Grid, { item: true, xs: 12, sm: 12 },
                    React.createElement(FormControlLabel, { name: "okagesama_no_mori_paid", control: React.createElement(Checkbox, { color: "primary" }), label: t('params.offerList.okagesamaNoMoriPaid'), labelPlacement: "end", checked: offerList.okagesamaNoMoriPaid, onChange: handleCheckboxChange, disabled: loading })))),
        React.createElement(MaterialTable, { title: t('pages.offerList.okagesamaNoMoriContributors'), model: "contributeToOkagesamaNoMori", isLoading: loading, columns: columns, data: contributeToOkagesamaNoMoris })));
};
export default OkagesamaNoMoriContributorTable;
